import { layout } from 'thewest/App.routing'

export const propertySegment = layout.component({
    type: 'lima',
    props: {
        verticalSpacing: 'xl',
        fixedRatios: ['16:9'],
        intermediateColumns: 2,
        finalColumns: 4,
        hideTeaser: false,
        hideByline: false,
        hasBackground: true,
        cardLayout: [
            ['teaserWithBackground'],
            ['teaserWithBackground'],
            [
                {
                    type: 'landscape',
                    format: 'landscape-paddingNoKicker',
                },
                {
                    type: 'landscape',
                    format: 'landscape-paddingNoKicker',
                },
                {
                    type: 'landscape',
                    format: 'landscape-paddingNoKicker',
                },
            ],
            ['teaserWithBackground'],
        ],
        cardOrientation: { type: 'Landscape-Portrait' },
        sectionHeader: {
            heading: 'Property',
            section: 'business',
            headingUrl: '/business/property',
        },
        dataDefinitionArgs: {
            type: 'curation',
            name: 'property',
            offset: 0,
            pageSize: 6,
        },
    },
})
